import React, { FC, useContext } from 'react';
import classNames from 'classnames';

import { useTranslation } from 'app/lang';

import { AuthContext } from '../../context';
import AuthorizationBody from '../AuthorizationModal/AuthorizationBody';
import AuthorizationFooter from '../AuthorizationModal/AuthorizationFooter';

import dictionary from './Authorization.dictionary.json';

import styles from '../../Signing.module.scss';

const Authorization: FC = () => {
  const { t } = useTranslation();
  const { authData: { errorMessage } } = useContext(AuthContext);

  const errorMessageClassNames = classNames(styles.errorMessage, {
    [styles.showErrorMessage]: errorMessage,
  });

  return (
    <>
      <p className={errorMessageClassNames}>
        {t(dictionary.authText)}
      </p>
      <AuthorizationBody />
      <AuthorizationFooter />
    </>
  );
};

export default Authorization;
